import { ReactNode } from "react";

export function PesquisaNpsLayout({ children }: { children: ReactNode }) {
  return (
    <div
      data-nps-scroll
      className="flex h-full min-h-0 flex-col overflow-y-auto overflow-x-hidden overscroll-y-contain bg-slate-100 text-slate-800"
    >
      <header className="sticky top-0 z-10 border-b border-slate-200 bg-white">
        <div className="mx-auto flex max-w-xl items-center justify-center px-4 py-3">
          <span className="text-sm font-bold tracking-wide text-brand-700">SEMOG · Pesquisa interna</span>
        </div>
      </header>
      <main className="mx-auto w-full max-w-[640px] flex-1 px-4 py-6 pb-12">{children}</main>
    </div>
  );
}

export function PesquisaEstado({ titulo, texto }: { titulo: string; texto: string }) {
  return (
    <PesquisaNpsLayout>
      <div className="rounded-2xl border border-slate-200 bg-white p-6 text-center shadow-card">
        <h1 className="text-xl font-bold">{titulo}</h1>
        <p className="mt-3 text-sm leading-relaxed text-slate-600">{texto}</p>
      </div>
    </PesquisaNpsLayout>
  );
}
